setEmailSignupConfirmation